import * as m from 'mithril';
import CustomSvgIcon from './CustomSvgIcon';

interface Option {
    value: string,
    label: string
}

interface Attrs {
    initialValue: string | null;
    options : Option[],
    onOptionSelected : (value:Option) => void        
}

function OptionList() : m.Component<Attrs> {   
    let selectedValue:string|null = null;    
    return {
        oninit(vnode) {
            selectedValue = vnode.attrs.initialValue;
        },

        view(vnode) {
            return m("div", {class:"list-group list-group-horizontal shadow-sm"}, 
                vnode.attrs.options.map(function(option){
                    return m("div", {
                        class:"list-group-item col text-center px-0 clickable",
                        onclick : function(event) {
                            event.preventDefault();
                            selectedValue = option.value;
                            vnode.attrs.onOptionSelected(option);
                        }
                    }, [
                        m(CustomSvgIcon, {
                            iconType:  (option.value == selectedValue)? 'radio_button_checked' : 'radio_button_unchecked', 
                            themeCssClass:'svg-info svg-medium',
                        }),     
                        m("span", {class:"text-truncate pl-1"}, option.label)
                    ])
                })
            );
        }
    }
}


export default OptionList;